import React from 'react';
import Select from 'react-select';
import classnames from 'classnames'
import { connect } from 'react-redux';
import { Formik, Form } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';
import { selectDefaultStyles } from '../../../styling/selectDefaultStyles';
import { withLocalize, Translate } from 'react-localize-redux';
import { toast } from '../../../common/toast';
import { writeErr } from '../../../common/logger';
import { popupActions } from '../../../../store/popupStore';
import { domainActions } from '../../../../store/domainStore';
import { windowActions } from '../../../../store/windowStore';
import { addSubjectSchema } from '../../validations/addSubjectSchema';
import { apiPost, getHostApi } from '../../../../store/apiWrapper';
import { isNullOrUndefined, isEmpty } from '../../../../store/storeFunctions';
import { repiActions, repiDomain, repiAddSubjectFields } from '../../../../store/repiStore';
import TabLink from '../../../search/tabLink';
import Message from '../../../common/message';
import FormMenuControl from '../../../common/formMenuControl'
import RepiSearchInput from '../../search/repiSearchInput';
import BbFormikCheckbox from '../../../styling/bbFormikCheckbox';

import IconFO from '../../../../img/icons/BBiconsFo';
import IconPO from '../../../../img/icons/BBiconsPo';
import IconFOP from '../../../../img/icons/BBiconsFop';

import '../../repi.scss';
import { repiDomainNotInitilized } from '../../repiUtils';

const TYPES = [
    { id: 3, label: "Repi.DataCorrection.AddSubject.PO",  name: "po" },
    { id: 1, label: "Repi.DataCorrection.AddSubject.FO",  name: "fo" },
    { id: 2, label: "Repi.DataCorrection.AddSubject.FOP", name: "fop" }
];

class RepiAddSubjectForm extends React.Component {
    state = {
        subjectType: 3,
        requesting: false,
        checkingData: false,
        validationErrors: [],
        validationWarnings: []
    };

    initialValues = {
        [repiAddSubjectFields.contributorSubjectId] : "",
        [repiAddSubjectFields.pin]: "",
        [repiAddSubjectFields.birthDate]: "",
        [repiAddSubjectFields.surname]: "",
        [repiAddSubjectFields.name]: "",
        [repiAddSubjectFields.alias]: "",
        [repiAddSubjectFields.country]: "CZ",
        [repiAddSubjectFields.companyId]: "",
        [repiAddSubjectFields.companyName]: ""
    };

    render() {
        return (
            <Formik
                enableReinitialize={true}
                initialValues={this.initialValues}
                validateOnChange={true}
                validationSchema={addSubjectSchema(this.props.translate, this.state.subjectType)}
                onSubmit={(values, { setSubmitting }) => this.handleSubmit(values, setSubmitting)}
            >
                {({ values, errors, touched, isSubmitting, setFieldValue }) => <Form>
                    <div className="columns is-desktop">
                        <div className="column is-4-desktop tabs tabs-form-menu">
                            <FormMenuControl>
                                <ul>
                                    {TYPES.map((t, i) => <TabLink
                                        key={t.id}
                                        type={t.id}
                                        selected={this.state.subjectType}
                                        onSelect={(value) => this.selectSearch(value)}
                                        icon={this.getIconBySubjectType(t.id)}
                                        titleKey={t.label}
                                        descriptionKey={`${t.label}.Description`}
                                        hr={i < (TYPES.length - 1)}
                                    />)}
                                </ul>
                            </FormMenuControl>
                        </div>
                        <div className="column">
                            <div className="card card-special" style={{ paddingTop: "1.5em" }}>
                                <div className="card-body">
                                    {this.renderWarning()}
                                    {this.renderSubjectForm({ values, errors, touched, isSubmitting, setFieldValue })}
                                    <button id="btn-submit-form"
                                        type="submit"
                                        style={{ display: "none" }}
                                        disabled={this.state.requesting === true || Object.keys(errors).length > 0}
                                    />
                                    <div style={{ textAlign: "center", marginTop: "2em" }}>
                                        {this.renderButtons(this.state.requesting === true || Object.keys(errors).length > 0)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>}
            </Formik>
        );
    }

    componentDidMount() {
        this.props.ensureDomainData(repiDomain.countries);
    }

    renderSubjectForm = (formik) => {
        switch (this.state.subjectType) {
            case 1: return this.renderSubjectFormFo(formik);
            case 2: return this.renderSubjectFormFop(formik);
            case 3: return this.renderSubjectFormPo(formik);
            default: return null;
        }
    }

    renderSubjectFormFo = (formik) => {
        return (
            <div className="columns is-multiline">
                <Input name={repiAddSubjectFields.contributorSubjectId} label={this.props.translate("Repi.Other.ContributorSubjectId")} formik={formik} isRequired />
                {this.renderCountrySelect(repiAddSubjectFields.country, this.props.translate("Repi.Search.Country"), formik)}
                <Input name={repiAddSubjectFields.name} label={this.props.translate("Repi.Search.Name")} formik={formik} isRequired />
                <Input name={repiAddSubjectFields.surname} label={this.props.translate("Repi.Search.Surname")} formik={formik} isRequired />
                <Input name={repiAddSubjectFields.pin} label={this.props.translate("Repi.Search.Pin")} formik={formik} />
                <Input name={repiAddSubjectFields.birthDate} label={this.props.translate("Repi.Search.BirthDate")} formik={formik} isDate />
                <Input name={repiAddSubjectFields.alias} label={this.props.translate("Repi.DataCorrection.Subject.Alias")} formik={formik} />
            </div>
        );
    }

    renderSubjectFormFop = (formik) => {
        return (
            <div className="columns is-multiline">
                <Input name={repiAddSubjectFields.contributorSubjectId} label={this.props.translate("Repi.Other.ContributorSubjectId")} formik={formik} isRequired />
                {this.renderCountrySelect(repiAddSubjectFields.country, this.props.translate("Repi.Search.Country"), formik)}
                <Input name={repiAddSubjectFields.companyId} label={this.props.translate("Repi.Search.CompanyId")} formik={formik} isRequired />
                <Input name={repiAddSubjectFields.companyName} label={this.props.translate("Repi.Search.CompanyName")} formik={formik} />
                <Input name={repiAddSubjectFields.name} label={this.props.translate("Repi.Search.Name")} formik={formik} />
                <Input name={repiAddSubjectFields.surname} label={this.props.translate("Repi.Search.Surname")} formik={formik} />
                <Input name={repiAddSubjectFields.pin} label={this.props.translate("Repi.Search.Pin")} formik={formik} />
                <Input name={repiAddSubjectFields.birthDate} label={this.props.translate("Repi.Search.BirthDate")} formik={formik} isDate />
                <Input name={repiAddSubjectFields.alias} label={this.props.translate("Repi.DataCorrection.Subject.Alias")} formik={formik} />
            </div>
        );
    }

    renderSubjectFormPo = (formik) => {
        return (
            <div className="columns is-multiline">
                <Input name={repiAddSubjectFields.contributorSubjectId} label={this.props.translate("Repi.Other.ContributorSubjectId")} formik={formik} isRequired />
                {this.renderCountrySelect(repiAddSubjectFields.country, this.props.translate("Repi.Search.Country"), formik)}
                <Input name={repiAddSubjectFields.companyId} label={this.props.translate("Repi.Search.CompanyId")} formik={formik} isRequired />
                <Input name={repiAddSubjectFields.companyName} label={this.props.translate("Repi.Search.CompanyName")} formik={formik} />
                <Input name={repiAddSubjectFields.alias} label={this.props.translate("Repi.DataCorrection.Subject.Alias")} formik={formik} />
            </div>
        );
    }

    renderCountrySelect = (name, label, formik, isRequired = true) => {
        const options = this.getCountrySelectOptions();
        const current = options.find(o => o.value === formik.values[name]);

        return (
            <div className="column is-6">
                <div className="repi-search-input-row repi-search-flex">
                    <div className="field bb-field" style={{ marginBottom: "0px" }}>
                        <label>{label}</label>{isRequired ? <span className="repi-search-input-star"> *</span> : null}
                        <Select
                            className="repi-data-correction-select"
                            closeMenuOnSelect={true}
                            field={name}
                            value={current}
                            styles={selectDefaultStyles}
                            isSearchable={true}
                            options={this.getCountrySelectOptions()}
                            hideSelectedOptions={false}
                            allowSelectAll={false}
                            onChange={(v) => formik.setFieldValue(name, v.value)}
                            placeholder=""
                            formatOptionLabel={({ value, label }) => (
                                <div style={{ display: "flex" }}>
                                    <span style={{minHeight: "1em", textAlign: "left", fontSize: "0.75em", whiteSpace: "nowrap" }} type={value} size="medium">
                                        {label}
                                    </span>
                                </div>
                            )}
                        />
                    </div>
                </div>
            </div>
        )
    }

    renderButtons = (submitDisabled) => {
        return (
            <button type="submit" disabled={submitDisabled}
                className={classnames('bb-button gradient-1', {'is-square': localStorage.locales_button_style === 'square' })}
            >
                {this.state.requesting === true || this.state.checkingData === true
                    ? <FontAwesomeIcon icon="cog" spin />
                    : <Translate id='Common.Button.Add.Subject' />}
            </button>
        );
    }

    renderWarning = () => {
        const noErrors = isNullOrUndefined(this.state.validationErrors) || this.state.validationErrors.length === 0;
        const noWarnings = isNullOrUndefined(this.state.validationWarnings) || this.state.validationWarnings.length === 0;

        if (noErrors && noWarnings)
            return null;

        const type = noErrors ? "warning" : "error";
        const message = this.props.translate(`Repi.DataCorrection.AddSubject.Validation.${(noErrors ? "Warnings" : "Errors")}`);
        const detail = this.props.translate("Repi.DataCorrection.AddSubject.Validation.Details");

        return (
            <div className="error-container error-container-wide" style={{ paddingBottom: "0.8em", paddingTop: "1em" }}>
                <Message type={type} message={<span>{message}. <a className="link-functional" onClick={() => this.displayValidationDetails()}>{detail}</a></span>} />
            </div>
        );
    }

    handleSubmit = (values, setSubmitting) => {
        this.setState(
            { validationErrors: [], validationWarnings: [], checkingData: true },
            () => this.postCheckData(values, setSubmitting)
        );
    }

    postCheckData = (values, setSubmitting) => {
        const data = { type: this.state.subjectType };
        Object.keys(values).forEach(k => {
            if (isEmpty(values[k]) || this.shouldFilterValueBySubjectType(this.state.subjectType, k))
                data[k] = null;
            else
                data[k] = values[k];
        });

        apiPost(getHostApi() + "/api/repi/subject/check", null, data,
            (s) => {
                if (!s.hasData || isNullOrUndefined(s.data) || isNullOrUndefined(s.data.validationResult)) {
                    toast(this.props.translate("Repi.DataCorrection.AddSubject.Fail"), "error");
                    writeErr("No data returned from /api/repi/subject/check");
                    this.props.close();
                    return;
                }

                if (s.data.validationResult.isValid === true) {
                    if (!isNullOrUndefined(s.data.candidateId)) {
                        const destReport = s.data.isInternal ? "DataCorrectionInternal" : "DataCorrectionContributor";
                        this.props.repiRedirect(`/report/${destReport}/${s.data.candidateId}`);
                    } else {
                        this.postSubject(data);
                    }
                } else {
                    this.setState({
                        validationErrors: s.data.validationResult.errors,
                        validationWarnings: s.data.validationResult.warnings
                    });
                }
            },
            (e) => {
                writeErr(e);
            },
            () => this.setState({ checkingData: false })
        );

        setSubmitting(false);
    }

    onSubjectTypeChanged = (e) => {
        const newValue = parseInt(e.target.value);
        if (isNullOrUndefined(newValue) || isNaN(newValue)) {
            writeErr("Could not parse new subject type value");
            return;
        }
        this.setState({ subjectType: newValue });
    }

    postSubject = (data) => {
        this.setState({ requesting: true });
        apiPost(getHostApi() + "/api/repi/subject/add", null, data,
            (s) => {
                if (!s.hasData || s.data !== true) {
                    toast(this.props.translate("Repi.DataCorrection.AddSubject.Fail"), "error");
                    writeErr("No data returned from /api/repi/subject/add");
                    return;
                }
                toast(this.props.translate("Repi.DataCorrection.AddSubject.Success"), "info");
            },
            (e) => {
                toast(this.props.translate("Repi.DataCorrection.AddSubject.Fail"), "error");
                writeErr(e);
            },
            () => {
                this.setState({ requesting: false });
            }
        );
    }

    getCountrySelectOptions = () => {
        const domain = this.props.domain;
        if (repiDomainNotInitilized(domain, repiDomain.countries))
            return [];

        return domain[repiDomain.countries].requestResult.map(d => ({
            value: d.shortening,
            label:d.label,
            code: d.shortening
        })).sort((a, b) => (a.label > b.label) ? 1 : -1);
    }

    selectSearch = (selected) => {
        if (selected !== this.state.subjectType) {
            this.setState({ subjectType: selected });
            this.props.closeAll();
        }
    }

    getIconBySubjectType = (st) => {
        switch (st) {
            case 1: return <IconFO className="tabs-icon" />;
            case 2: return <IconFOP className="tabs-icon" />;
            case 3: return <IconPO className="tabs-icon" />;
            default: return null;
        }
    }

    shouldFilterValueBySubjectType = (st, key) => {
        if (st === 1 && (key === repiAddSubjectFields.companyId || key === repiAddSubjectFields.companyName))
            return true;

        switch (st) {
            case 1: return key === repiAddSubjectFields.companyId || key === repiAddSubjectFields.companyName;
            case 3: return key === repiAddSubjectFields.pin || key === repiAddSubjectFields.birthDate ||
                key === repiAddSubjectFields.name || key === repiAddSubjectFields.surname;
            default: return false;
        }
    }

    displayValidationDetails = () => {
        this.props.showPopup("repiAddSubjectValidationErrorsPopup", {
            open: true,
            close: () => { this.props.hidePopup() },
            data: {
                errors: this.state.validationErrors,
                warnings: this.state.validationWarnings,
            }
        });
    }
}

const Input = ({name, label, formik, isDate = false, disabled = false, isRequired = false}) => {
    return (
        <div className="column is-6">
            <RepiSearchInput name={name} label={label} formik={formik} isDate={isDate} disabled={disabled} isRequired={isRequired} />
        </div>
    );
}

export default connect(
    state => ({ domain: state.domain }),
    dispatch => bindActionCreators({ ...domainActions, ...repiActions, ...windowActions, ...popupActions }, dispatch),
)(withLocalize(RepiAddSubjectForm));
